import React from 'react';
import {ReactNodeGenerator} from '../../../../../lib/helpers';
import {OpenEndedQuestionEditStore} from './OpenEndedQuestionEditStore';
import {OpenEndedQuestionPreview} from './parts/OpenEndedQuestionPreview';
import {OpenEndedQuestionTextArea} from './parts/OpenEndedQuestionTextArea';

export function* openEndedQuestionEditStoreRenderer(store: OpenEndedQuestionEditStore): ReactNodeGenerator {
  yield (
    <div key="text-area" className="row">
      <div className="col">
        <div className="form-group">
          <OpenEndedQuestionTextArea store={store}/>
        </div>
      </div>
    </div>);

  yield (<OpenEndedQuestionPreview key="preview" store={store}/>);
}
